exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aireach-activate-modal-content .tips[data-v-e69292a0]{margin-bottom:16px}.aireach-activate-modal-content .tips-content-link[data-v-e69292a0]{cursor:pointer}.aireach-activate-modal-content .form-actions[data-v-e69292a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;gap:10px}", ""]);

// exports
